/*
 * Wijn.com welkomstpop-up (sectie wijncom-welkom).
 * - Eén keer per bezoeker (localStorage). Zonder opslag geen pop-up, anders komt hij op elke pagina terug.
 * - Komt pas later: minstens [wacht] seconden na binnenkomst op de site (telt door over pagina's heen)
 *   en minstens NA_KEUZE seconden na de cookiekeuze, zodat banner en pop-up nooit samen komen.
 * - Computer: kaart rechtsonder, de pagina blijft bruikbaar. Telefoon: venster in het midden.
 * - "Korting activeren" gaat via /discount/CODE terug naar dezelfde pagina; daarna een korte melding.
 * - Zonder code (welkomstversie): geen codevak en geen activeerknop, de knop is een gewone link.
 */
(function () {
  var GEZIEN = 'wijncom-welkom-2026';
  var ACTIEF = 'wijncom-welkom-actief';
  var START = 'wijncom-welkom-start';
  var KEUZE = 'wijncom-welkom-keuze';
  var NA_KEUZE = 15;

  var sjabloon = document.getElementById('wijncom-welkom-sjabloon');
  if (!sjabloon || !('content' in sjabloon)) return;
  /* Zoekmachines en meetrobots krijgen hem niet (Google telt pop-ups mee bij mobiel) */
  if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;

  var code = sjabloon.dataset.code;
  var wacht = parseInt(sjabloon.dataset.wacht, 10);
  var tot = new Date((sjabloon.dataset.tot || '') + 'T23:59:59+01:00');
  if (isNaN(wacht)) wacht = 20;

  function lees(opslag, sleutel) {
    try { return window[opslag].getItem(sleutel); } catch (e) { return 'geen-opslag'; }
  }

  function schrijf(opslag, sleutel, waarde) {
    try {
      if (waarde === null) window[opslag].removeItem(sleutel);
      else window[opslag].setItem(sleutel, waarde);
    } catch (e) {}
  }

  /* Melding na het activeren van de code */
  if (lees('sessionStorage', ACTIEF) === '1') {
    schrijf('sessionStorage', ACTIEF, null);
    var melding = sjabloon.content.querySelector('.wwk-melding').cloneNode(true);
    document.body.appendChild(melding);
    requestAnimationFrame(function () { melding.classList.add('is-zichtbaar'); });
    setTimeout(function () {
      melding.classList.remove('is-zichtbaar');
      setTimeout(function () { melding.remove(); }, 400);
    }, 6000);
    return;
  }

  if (lees('localStorage', GEZIEN)) return;
  if (!isNaN(tot.getTime()) && new Date() > tot) return;

  /* Eerste pagina van dit bezoek: daar begint de wachttijd */
  var start = parseInt(lees('sessionStorage', START), 10);
  if (isNaN(start)) {
    start = Date.now();
    schrijf('sessionStorage', START, String(start));
  }

  function zichtbaar(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    var stijl = getComputedStyle(el);
    return stijl.display !== 'none' && stijl.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
  }

  function keuzeOpen() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.shouldShowBanner !== 'function') return false;
    try {
      return privacy.shouldShowBanner() && privacy.currentVisitorConsent().marketing === '';
    } catch (e) {
      return false;
    }
  }

  var gepland = null;

  /* Keuze gemaakt: opnieuw plannen, want er moet eerst NA_KEUZE seconden rust zijn */
  document.addEventListener('visitorConsentCollected', function () {
    schrijf('sessionStorage', KEUZE, String(Date.now()));
    if (!document.querySelector('dialog.wwk')) plan();
  });

  function plan() {
    var moment = start + wacht * 1000;
    var keuze = parseInt(lees('sessionStorage', KEUZE), 10);
    if (!isNaN(keuze)) moment = Math.max(moment, keuze + NA_KEUZE * 1000);
    clearTimeout(gepland);
    gepland = setTimeout(probeer, Math.max(0, moment - Date.now()));
  }

  /* 29-9-2026: niet over een ander venster heen (winkelwagenlade, zoeken, menu, snel toevoegen) */
  function anderVensterOpen() {
    if (document.querySelector('dialog[open]:not(.wwk)')) return true;
    if (document.querySelector('#Details-menu-drawer-container[open], header-drawer details[open]')) return true;
    return false;
  }

  /* 29-9-2026: op de computer ligt de kaart rechtsonder. Op een productpagina pas tonen als de
     koopknop, de keuze fles/doos en de meeschuivende koopbalk niet onder dat vlak liggen. */
  var kaartVlak = null;
  function meetKaart() {
    if (kaartVlak) return kaartVlak;
    var proef = sjabloon.content.querySelector('dialog.wwk').cloneNode(true);
    proef.style.visibility = 'hidden';
    proef.style.animation = 'none';
    proef.setAttribute('open', '');
    proef.setAttribute('aria-hidden', 'true');
    document.body.appendChild(proef);
    var r = proef.getBoundingClientRect();
    proef.remove();
    if (r.width > 0 && r.height > 0) {
      /* Als afstand tot de rechter- en onderrand, zodat het ook klopt als het venster anders wordt */
      kaartVlak = { breed: r.width, hoog: r.height, rechts: window.innerWidth - r.right, onder: window.innerHeight - r.bottom };
    }
    return kaartVlak;
  }

  function koopblokOnderKaart() {
    if (!window.matchMedia('(min-width: 750px)').matches) return false;
    var delen = document.querySelectorAll('.product-details product-form-component, .product-details .purchase-type-options, .sticky-add-to-cart__bar');
    if (!delen.length) return false;
    var k = meetKaart();
    if (!k) return false;
    var rechts = window.innerWidth - k.rechts;
    var onder = window.innerHeight - k.onder;
    var links = rechts - k.breed;
    var boven = onder - k.hoog;
    for (var i = 0; i < delen.length; i++) {
      var r = delen[i].getBoundingClientRect();
      if (r.width === 0 || r.height === 0) continue;
      if (r.right > links && r.left < rechts && r.bottom > boven && r.top < onder) return true;
    }
    return false;
  }

  /* 5-10-2026 (sitecheck T11): niet openen vlak na een tik of scroll van de bezoeker, anders vangt
     de pop-up die tik weg (gezien op 'Doos +6'). Pas RUST ms na de laatste tik of scroll. */
  var RUST = 2000;
  var laatsteActie = 0;
  function actie() { laatsteActie = Date.now(); }
  ['pointerdown', 'touchstart', 'scroll'].forEach(function (soort) {
    window.addEventListener(soort, actie, { passive: true, capture: true });
  });

  var wachtOpScroll = false;
  function straksOpnieuw() {
    clearTimeout(gepland);
    gepland = setTimeout(probeer, 5000);
    if (!wachtOpScroll) {
      wachtOpScroll = true;
      var bijScroll = function () {
        window.removeEventListener('scroll', bijScroll);
        wachtOpScroll = false;
        clearTimeout(gepland);
        gepland = setTimeout(probeer, 400);
      };
      window.addEventListener('scroll', bijScroll, { passive: true });
    }
  }

  function probeer() {
    /* Nog geen cookiekeuze: niets doen, de keuze plant hem opnieuw in */
    if (zichtbaar('shopify-pc__banner') || keuzeOpen()) return;
    if (zichtbaar('shopify-pc__prefs__dialog')) {
      gepland = setTimeout(probeer, 5000);
      return;
    }
    if (document.querySelector('dialog.wwk')) return;
    if (anderVensterOpen() || koopblokOnderKaart()) {
      straksOpnieuw();
      return;
    }
    var sindsActie = Date.now() - laatsteActie;
    if (sindsActie < RUST) {
      clearTimeout(gepland);
      gepland = setTimeout(probeer, RUST - sindsActie + 50);
      return;
    }
    toon();
  }

  function toon() {
    if (document.querySelector('dialog.wwk')) return;
    var dialoog = sjabloon.content.querySelector('dialog.wwk').cloneNode(true);
    if (typeof dialoog.showModal !== 'function') return;
    var hoek = window.matchMedia('(min-width: 750px)').matches;
    document.body.appendChild(dialoog);

    var knop = dialoog.querySelector('[data-wwk-activeer]');
    var pad = location.pathname + location.search;
    if (knop) knop.href = knop.getAttribute('href') + '?redirect=' + encodeURIComponent(pad);

    function sluit() {
      if (dialoog.open) dialoog.close();
    }

    function esc(event) {
      if (event.key === 'Escape') sluit();
    }

    dialoog.addEventListener('close', function () {
      document.documentElement.classList.remove('wwk-open');
      document.removeEventListener('keydown', esc);
      dialoog.remove();
    });
    dialoog.addEventListener('click', function (event) {
      if (event.target === dialoog) sluit();
    });
    dialoog.querySelector('[data-wwk-sluit]').addEventListener('click', sluit);
    document.addEventListener('keydown', esc);

    if (knop) knop.addEventListener('click', function () {
      schrijf('localStorage', GEZIEN, 'geactiveerd');
      schrijf('sessionStorage', ACTIEF, '1');
    });

    var kopieer = dialoog.querySelector('[data-wwk-kopieer]');
    if (kopieer) kopieer.addEventListener('click', function () {
      function klaar() {
        kopieer.textContent = kopieer.dataset.klaar;
        kopieer.classList.add('is-klaar');
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(klaar, function () {});
      } else {
        var bereik = document.createRange();
        bereik.selectNodeContents(dialoog.querySelector('.wwk__code-waarde'));
        var selectie = window.getSelection();
        selectie.removeAllRanges();
        selectie.addRange(bereik);
      }
    });

    if (hoek) {
      /* Kaart rechtsonder. Open zetten zonder show(): zo pakt hij de focus niet af van wat de bezoeker doet */
      dialoog.setAttribute('open', '');
    } else {
      document.documentElement.classList.add('wwk-open');
      dialoog.showModal();
      /* Focus op de kaart zelf, niet op de eerste knop (anders staat er meteen een focusrand om Kopieer) */
      var kaart = dialoog.querySelector('.wwk__kaart');
      kaart.setAttribute('tabindex', '-1');
      kaart.focus({ preventScroll: true });
    }
    schrijf('localStorage', GEZIEN, 'gezien');
  }

  function begin() {
    plan();
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], begin);
  } else {
    begin();
  }
})();
